import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';

type Props = {
  content: CmsApiDocument;
};

export function getCmsApiDocumentHomeMeta({ content }: Props) {
  const { subsite } = content;

  const hasHomePage = Boolean(subsite.homePage);
  const subsiteHasHomePage = hasHomePage || Boolean(subsite.homePage);
  const homePageUrl = subsite.homePage ? subsite.homePage.url : '';

  return { hasHomePage, subsiteHasHomePage, homePageUrl };
}
